import L from 'leaflet';

/**
 * @param {L.Map} map - Map.
 * @returns User shapes layergroup.
 */
const getUserShapesLayerGroup = (map) => {
    const userShapesLayerGroup = new L.LayerGroup();
    map.pm.setGlobalOptions({ layerGroup: userShapesLayerGroup });
    return userShapesLayerGroup;
};

export { getUserShapesLayerGroup };
